import axios from "../../../services/axios-config";

export async function saveCompanyNotes({ companyId, notes }) {
    try{
        const response = await axios.patch("/admin/companies/notes", {
          companyId,
          notes,
        });
      
        return response?.data?.notes ?? "";

    } catch (error) {
        console.error('ERROR - SAVE COMPANY NOTES SERVICE:', error);
        throw error;
    }
}
